import React, {
  ButtonHTMLAttributes,
  PropsWithChildren,
  ReactNode,
} from 'react';
import { StyledButton, StyledLabelColumn, StyledSubLabel, StyledWrapper } from './styles';

export type ButtonVariant = 'primary' | 'secondary' | 'tertiary';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  disabled?: boolean;
  label?: string;
  /** Small, subtle secondary text stacked below `label` (e.g. "approve pending changes"). */
  subLabel?: string;
  iconLeft?: ReactNode;
  iconRight?: ReactNode;
  fullWidth?: boolean;
  width?: string;
  testID?: string;
  isDarkBackground?: boolean;
}

export const Button: React.FC<PropsWithChildren & ButtonProps> = ({
  children,
  variant = 'primary',
  disabled = false,
  label,
  subLabel,
  iconRight,
  iconLeft,
  fullWidth = false,
  width = 'auto',
  testID,
  type = 'button',
  isDarkBackground = false,
  ...props
}) => {
  return (
    <StyledButton
      type={type}
      variant={variant}
      disabled={disabled}
      fullWidth={fullWidth}
      width={width}
      data-testid={testID}
      isDarkBackground={isDarkBackground}
      {...props}
    >
      <StyledWrapper>
        {iconLeft}
        {subLabel ? (
          <StyledLabelColumn>
            <span>{label ?? children}</span>
            <StyledSubLabel data-testid={testID ? `${testID}-sub-label` : undefined}>
              {subLabel}
            </StyledSubLabel>
          </StyledLabelColumn>
        ) : (
          label ?? children
        )}
        {iconRight}
      </StyledWrapper>
    </StyledButton>
  );
};
